import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useGetAvailableLanguages, getLanguagesInputValue, useSelectLanguage } from "../../hooks/global/Languages";
import { validate, validateArray } from '../../helpers/general';

function GroupQuestionsTextInput({ index, isAnswer = false, value = [], onChange, isNew = false, error = false, required = true }) {
    const { t } = useTranslation();
    const availableLan = useGetAvailableLanguages()

    const { selectTextByLanguage } = useSelectLanguage();

    const [inputValue, setInputValue] = useState(value);
    const [validateData, setValidateData] = useState();
    const [isNewEntry, setIsNewEntry] = useState(isNew);
    const [answer, setAnswer] = useState(isAnswer);

    const validateRules = availableLan.map((lng) => { return { index: lng, regex: /^.+$/s, condition: required } });

    useEffect(() => {
        if (isAnswer) {
            setAnswer(isAnswer);
        }
    }, [isAnswer]);


    useEffect(() => {
        var temp = inputValue;
        if (isNewEntry) {
            temp = answer ? [{ text: getLanguagesInputValue({}, availableLan), value: '', order: 0 }] : getLanguagesInputValue({}, availableLan);
            setInputValue(temp);
        }

        const validatorErrors = Array.isArray(temp) ? validateArray(temp, validateRules) : validate(temp, validateRules);

        onChange?.({
            type: 'onChange',
            data: temp,
            index: index,
            error: validatorErrors?.e
        })

    }, [isNew, value]);


    useEffect(() => {
        if (error) {
            const validatorErrors = Array.isArray(inputValue) ? validateArray(inputValue, validateRules) : validate(inputValue, validateRules);
            if (error) setValidateData(validatorErrors);
        }
    }, [error]);

    const handleInputChange = (event) => {
        event.persist();
        let temp;
        if (!Array.isArray(inputValue)) {
            temp = { ...inputValue }
            temp[event.target.name] = event.target.value
            setInputValue(temp);
        } else {
            temp = [...inputValue]
            temp[event.target.dataset.index].text[event.target.name] = event.target.value
            temp[event.target.dataset.index].value = event.target.value
            setInputValue(temp);
        }

        const validatorErrors = Array.isArray(temp) ? validateArray(temp, validateRules) : validate(temp, validateRules);
        if (error) setValidateData(validatorErrors);


        setIsNewEntry(false);
        onChange?.({
            type: 'onChange',
            data: temp,
            index: index,
            error: validatorErrors?.e
        })
        // isNew = false;
    };

    const handleAddAnswer = () => {
        setInputValue([...inputValue, { text: {}, value: '', order: 0 }]);
    }

    const handleRemoveAnswer = (i) => {
        setInputValue(inputValue.filter((_, e) => e !== i));
        onChange?.({
            type: 'onChange',
            data: inputValue.filter((_, e) => e !== i),
            index: index,
        })
    }

    return (
        <>
            {inputValue !== null && (
                <>
                    {(answer) ? (<>

                        {inputValue?.map((element, key) => {
                            return (
                                <div key={key} className="editMe-field editMe-fieldRadio" >
                                    {availableLan.map((lng, i) => {
                                        return (
                                            <div className="langSelectInputWrap" key={lng}>
                                                <label>{lng}: </label>
                                                <div>
                                                    {<input
                                                        type="text"
                                                        key={key + lng}
                                                        tabIndex="0"
                                                        name={lng}
                                                        data-index={key}
                                                        value={element?.text?.[lng] || ""}
                                                        onChange={handleInputChange}
                                                        placeholder={t("admin.common.enter")}
                                                        autoFocus={true} />}
                                                </div >
                                                {
                                                    (validateData?.e && key in validateData.newValidateData && !validateData.newValidateData[key][lng]) &&
                                                    <span className="validation">{t("err.req")}</span>
                                                }
                                            </div>);
                                    })}
                                    <span className="removeOption" onClick={(e) => { handleRemoveAnswer(key) }}></span>
                                </div>
                            );
                        })}
                        <div className="blueBtnWrap">
                            <button type="button" className="btn" onClick={handleAddAnswer}>{t("admin.group.addA")}</button>
                        </div>
                    </>
                    ) : (
                        availableLan.map((lng, key) => {
                            return (
                                <div className="langSelectInputWrap" key={lng}>
                                    <label>{lng}: </label>
                                    <div>
                                        <input
                                            type="text"
                                            key={lng}
                                            tabIndex="0"
                                            name={lng}
                                            value={inputValue[lng] || ""}
                                            onChange={handleInputChange}
                                            placeholder="Enter a value"
                                            autoFocus={true} />
                                    </div >
                                    {(validateData?.e && !validateData.newValidateData[lng]) && <span className="validation">{t("err.req")}</span>}
                                </div>
                            );
                        }))
                    }
                </>)}
        </>);

}

export default GroupQuestionsTextInput;
